module.exports = "/images/cerrar.svg?bbd0340b64f0d02c46256cf262090e36";